const SVG_NS = 'http://www.w3.org/2000/svg';

function makeCookieIcon() {
  const svg = document.createElementNS(SVG_NS, 'svg');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('width', '22');
  svg.setAttribute('height', '22');
  svg.setAttribute('aria-hidden', 'true');
  svg.setAttribute('focusable', 'false');

  const path = document.createElementNS(SVG_NS, 'path');
  path.setAttribute('fill', 'currentColor');
  path.setAttribute('d', 'M21.6 11.4c-1.2 0-2.2-1-2.2-2.2 0-.4-.4-.7-.8-.6-1.5.4-3-.7-3.1-2.2 0-.4-.4-.6-.8-.5-1.6.5-3.2-.8-2.9-2.5.1-.4-.2-.8-.6-.9-.5-.1-1-.1-1.5-.1-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10c0-.4 0-.7-.1-1.1zM7.5 16.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm.5-7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm5 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3-4a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z');

  svg.appendChild(path);
  return svg;
}

export class ReopenButton {
  constructor({ onClick, label, position = 'bottom-left' }) {
    this.onClick = onClick;
    this.label = label;
    this.position = position;
    this._el = null;
  }

  show() {
    if (this._el) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = `nc-reopen nc-reopen-${this.position}`;
    btn.setAttribute('aria-label', this.label);
    btn.setAttribute('title', this.label);
    btn.appendChild(makeCookieIcon());
    btn.addEventListener('click', () => this.onClick?.());
    document.body.appendChild(btn);
    this._el = btn;
  }

  hide() {
    this._el?.remove();
    this._el = null;
  }
}
